import { render } from "./Carousel.vue?vue&type=template&id=3db39862&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=3db39862&lang=scss"
import "./Carousel.vue?vue&type=style&index=1&id=3db39862&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db39862"]])

export default __exports__